import { render, staticRenderFns } from "./FacturasTableWithDeuda.vue?vue&type=template&id=47936b77&scoped=true"
import script from "./FacturasTableWithDeuda.vue?vue&type=script&lang=js"
export * from "./FacturasTableWithDeuda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47936b77",
  null
  
)

export default component.exports